import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx, renderList as _renderList, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "logo-test" }
const _hoisted_2 = {
  key: 0,
  style: {"height":"30px"}
}
const _hoisted_3 = {
  key: 0,
  style: {"height":"40px"}
}
const _hoisted_4 = {
  key: 1,
  class: "text-truncate text-h4"
}
const _hoisted_5 = { class: "pt-3 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_toolbar_title, {
      style: {"width":"256px"},
      class: "text-center"
    }, {
      default: _withCtx(() => [
        (_ctx.filteredAccountingFirms.length > 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogChangeAccountingFirm = true)),
              style: {"cursor":"pointer"}
            }, [
              (_ctx.logo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_img, {
                      src: _ctx.logo,
                      height: "30px"
                    }, null, 8, ["src"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.logo ? 'text-truncate text-subtitle-2' : 'text-truncate text-h4')
              }, _toDisplayString(_ctx.currentAccountingFirmName), 3)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.logo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_v_img, {
                      src: _ctx.logo,
                      height: "40px"
                    }, null, 8, ["src"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.currentAccountingFirmName), 1))
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialogChangeAccountingFirm,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogChangeAccountingFirm) = $event)),
      "min-width": !_ctx.$vuetify.display.mobile ? '650px' : undefined,
      fullscreen: _ctx.$vuetify.display.mobile,
      "hide-overlay": _ctx.$vuetify.display.mobile,
      title: "Changer de cabinet"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_text_field_filled, {
            modelValue: _ctx.searchAccountingFirm,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchAccountingFirm) = $event)),
            outlined: "",
            label: "Entrez le nom d'un cabinet",
            autofocus: "",
            density: "compact"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_list, { style: {"overflow-y":"auto","height":"30vh"} }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAccountingFirms, (accountingFirm) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: accountingFirm.id,
                  onClick: ($event: any) => (_ctx.switchAccountingFirm(accountingFirm)),
                  class: "mb-2"
                }, {
                  append: _withCtx(() => [
                    (accountingFirm.id === _ctx.currentAccountingFirmId)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          size: "small",
                          color: "primary"
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("$fa-check-circle")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_icon, { color: "grey lighten-1" }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("$chevron_right")
                      ])),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(accountingFirm.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_list_item_subtitle)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "min-width", "fullscreen", "hide-overlay"])
  ]))
}